import { useMutation } from 'react-query';

import { extractBattleCardToCsv as mutationFn } from 'api/endPoints/extractBattleCardToCsv';

export const useMutationRowsBoardToCsv = () => {
    return useMutation<unknown, QueryError, IUseMutationRowsBoardToCsvPayload>((params) => mutationFn(params));
};

interface IUseMutationRowsBoardToCsvPayload {
    fileName: string;
    filter: any;
    isCompact?: boolean;
}
